import React, { useMemo } from 'react';
import BaseSchemaForm from '../BaseSchemaForm/BaseSchemaForm';
import BaseObjectFieldTemplate from '../ObjectFieldTemplate/ObjectFieldTemplate';
import BaseGroupTemplate from '../GroupTemplate/SimpleGroupTemplate';
import BaseArrayTemplate from '../ArrayTemplate/ArrayTemplate';
import TitleField from '../TitleField/TitleField';
import DescriptionField from '../DescriptionField/DescriptionField';
import BaseTextTemplate from '../TextTemplate/TextTemplate';
import CheckboxWidget from '../Widgets/CheckboxWidget';
import CheckboxesWidget from '../Widgets/CheckboxesWidget';
import DateWidget from '../Widgets/DateWidget';
import LikertWidget from '../Widgets/LikertWidget';
import RadioWidget from '../Widgets/RadioWidget';
import RichTextWidget from '../Widgets/RichtextWidget';
import SelectWidget from '../Widgets/SelectWidget';
import SortDirectionWidget from '../../Tables/SortDirectionWidget';
import TextAreaWidget from '../Widgets/TextareaWidget';
import TextWidget from '../Widgets/TextWidget';
import HiddenIndicator from '../HiddenIndicator/HiddenIndicator';
import ReadOnlyIndicator from '../ReadOnlyIndicator/ReadOnlyIndicator';
import LockedIndicator from '../LockedIndicator/LockedIndicator';
import PubliclyAvailableIndicator from '../PubliclyAvailableIndicator/PubliclyAvailableIndicator';
var WIDGETS = {
  checkbox: CheckboxWidget,
  checkboxes: CheckboxesWidget,
  date: DateWidget,
  likert: LikertWidget,
  radio: RadioWidget,
  richtext: RichTextWidget,
  select: SelectWidget,
  sort: SortDirectionWidget,
  text: TextWidget,
  textarea: TextAreaWidget
};
export var ICONS = {
  HIDDEN: HiddenIndicator,
  READ_ONLY: ReadOnlyIndicator,
  LOCKED: LockedIndicator,
  PUBLICLY_AVAILABLE: PubliclyAvailableIndicator
};
var FIELDS = {
  TitleField: TitleField,
  DescriptionField: DescriptionField
};
export default function StaticForm(_ref) {
  var _ref$ArrayFieldTempla = _ref.ArrayFieldTemplate,
    ArrayFieldTemplate = _ref$ArrayFieldTempla === void 0 ? BaseArrayTemplate : _ref$ArrayFieldTempla,
    _ref$ObjectFieldTempl = _ref.ObjectFieldTemplate,
    ObjectFieldTemplate = _ref$ObjectFieldTempl === void 0 ? BaseObjectFieldTemplate : _ref$ObjectFieldTempl,
    FieldTemplate = _ref.FieldTemplate,
    _ref$TextTemplate = _ref.TextTemplate,
    TextTemplate = _ref$TextTemplate === void 0 ? BaseTextTemplate : _ref$TextTemplate,
    _ref$GroupTemplate = _ref.GroupTemplate,
    GroupTemplate = _ref$GroupTemplate === void 0 ? BaseGroupTemplate : _ref$GroupTemplate,
    children = _ref.children,
    component = _ref.component,
    fields = _ref.fields,
    _ref$indentFields = _ref.indentFields,
    indentFields = _ref$indentFields === void 0 ? false : _ref$indentFields,
    formContext = _ref.formContext,
    formData = _ref.formData,
    formRef = _ref.formRef,
    icons = _ref.icons,
    onChange = _ref.onChange,
    onError = _ref.onError,
    onSubmit = _ref.onSubmit,
    schema = _ref.schema,
    size = _ref.size,
    transformErrors = _ref.transformErrors,
    uiSchema = _ref.uiSchema,
    validate = _ref.validate,
    widgets = _ref.widgets,
    view = _ref.view;
  var schemaWidgets = useMemo(function () {
    return Object.assign({}, WIDGETS, widgets);
  }, [widgets]);
  var schemaIcons = useMemo(function () {
    return Object.assign({}, ICONS, icons);
  }, [icons]);
  var formFields = useMemo(function () {
    return Object.assign({}, FIELDS, fields);
  }, [fields]);
  return /*#__PURE__*/React.createElement(BaseSchemaForm, {
    ArrayFieldTemplate: ArrayFieldTemplate,
    FieldTemplate: FieldTemplate,
    ObjectFieldTemplate: ObjectFieldTemplate,
    TextTemplate: TextTemplate,
    GroupTemplate: GroupTemplate,
    component: component,
    fields: formFields,
    indentFields: indentFields,
    formContext: formContext,
    formData: formData,
    formRef: formRef,
    icons: schemaIcons,
    onChange: onChange,
    onError: onError,
    onSubmit: onSubmit,
    schema: schema,
    transformErrors: transformErrors,
    uiSchema: uiSchema,
    validate: validate,
    widgetSize: size,
    widgets: schemaWidgets,
    view: view
  }, children);
}